<template>
    <div class="container p-3">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="alert alert-danger">
                    <h1>Your attempt to make a payment failed.</h1>
                    <div v-if="actions.length > 0">
                        <div v-for="action in actions">
                            <p><a class="alert-link" @click.prevent="act(action)" href="#">Continue to the form</a> if you'd like to try again.</p>
                            <AsyncOperationStatus :promise="action.promise" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import getData from "../../admin/lib/getData";
import { useMainStore } from "@/mainStore";
import { ResumeFailure } from "@cs/ResumeFailure";
import AsyncOperationStatus from "@/lib/AsyncOperationStatus.3.vue";
export type JsResumeFailure = Omit<ResumeFailure, "Actions"> & { Actions?: (NonNullable<ResumeFailure["Actions"]>[0] & { promise?: Promise<void> | null })[] };
export default defineComponent({
    components: {
        AsyncOperationStatus,
    },
    setup() {
        const mainStore = useMainStore();
        const extraData = ref(null as null | JsResumeFailure);
        const failureMessages = computed(() => {
            return extraData.value?.FailureMessages ?? [];
        });
        const actions = computed(() => {
            const result = extraData.value?.Actions ?? [];
            for (let act of result) {
                if (!("promise" in act)) {
                    act.promise = null; // eslint-disable-line vue/no-side-effects-in-computed-properties
                }
            }
            return result;
        });
        const act = async (action: NonNullable<JsResumeFailure["Actions"]>[0]) => {
            action.promise = (async () => {
                const url = await mainStore.getUrl(action.UrlType, action.UrlData);
                window.location.assign(url);
            })();
        };
        (async () => {
            extraData.value = (await getData(mainStore, "FailedPaymentResume", () => {
                throw new Error();
            })) as JsResumeFailure;
        })();

        return {
            failureMessages,
            actions,
            act,
        };
    },
});
</script>
